<template>
  <div>
    <v-row dense class="mb-4">
      <v-col cols="12" md="6">
        <v-switch
          v-model="settings.guest.meal_in_restaurant"
          inset
          :label="$t('meal_in_restaurant')"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-switch
          v-model="settings.guest.personal_takeover"
          inset
          :label="$t('personal_takeover')"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-switch
          v-model="settings.guest.restoran_delivery"
          inset
          :label="$t('restaurant_delivers')"
          hide-details
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-switch
          v-model="settings.guest.post_delivery"
          inset
          hide-details
          :label="$t('post_delivery')"
        />
      </v-col>
    </v-row>

    <v-row dense v-if="settings.guest.restoran_delivery" class="mb-4">
      <v-col cols="12" md="6">
        <text-field
          v-model="settings.guest.delivery_price"
          :label="$t('delivery_price')"
          hide-details
        />
      </v-col>
      <v-col cols="12" md="6">
        <text-field
          v-model="settings.guest.minimal_price"
          type="number"
          :label="$t('minimal_price')"
          hide-details
        />
      </v-col>
    </v-row>

    <v-row dense v-if="settings.guest.post_delivery" class="mb-4">
      <v-col cols="12" md="6">
        <text-field
          v-model="settings.guest.post_price"
          :label="$t('delivery_price_post')"
          hide-details
        />
      </v-col>
      <v-col cols="12" md="6">
        <text-field
          v-model="settings.guest.post_minimal_price"
          :label="$t('minimal_price_post')"
          hide-details
        />
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="12">
        <text-area
          v-model="settings.guest.post_description"
          :label="$t('post_description')"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "GuestConsumptionSection",
  props: {
    settings: {
      type: Object,
      required: true,
    },
  },
};
</script>
